import { ErrorIcon } from "components/Icons/Error";

import { ErrorVariant, ItemInfo } from "./types";

export const messages: Record<ErrorVariant, ItemInfo> = {
  damagePhotos: {
    icon: () => <ErrorIcon height="32" width="32" alt="Error" />,
    translationKey: "damage_photos.error.duplicate",
  },
  vehiclePhotos: {
    icon: () => <ErrorIcon height="32" width="32" />,
    translationKey: "vehicle_corner_photos.error.duplicate",
  },
};
